module.exports = __webpack_public_path__ + "static/media/server2.bc9d9467.png";